import { gql } from '@apollo/client'

export default gql(`
    mutation batchUnpublishAssets($batchJobId: ID!) {
        batchUnpublishAssets(
            batchJobId: $batchJobId
        ) {
            isUnpublished
        }
    }`
)
